<template>
    <div>
        <div class="page-content">
            <!-- 图片新闻 -->
            <div class="company_trends">
                <div class="img_news">
                    <el-carousel height="100%">
                        <el-carousel-item v-for="item in pictureList" :key="item.id" :interval="2000">
                            <img class="cursor" :src="imageBaseUrl + item.imgUrl" alt=""
                                @click="ShowDetail(item.id, 'gsdt', '图片新闻')">
                            <div class="carousel_label">{{ item.title }}</div>
                            {{ item }}
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="trends_news ">
                    <div class="new_title">
                        <img src="../../assets/images/new-ico.png" /> 公司动态
                    </div>
                    <div class="new_list">
                        <div class="list_art cursor" v-for="(item, index) in lits.slice(0, 6)" :key="index"
                            @click="ShowDetail(item.id,'gsdt')">
                            <!-- <div class="time"> {{ item.publishTime.slice(5, 10) }}</div> -->
                            <div class="list-title">
                                <div class="art_title"> {{ item.title }}</div>
                                <div class="art_time"> {{ item.publishTime.slice(5, 10) }}</div>
                                <!-- <div class="art_content_short">{{ item.content }}</div> -->
                                <!-- <div class="art_content_short">11月20日，省道S7871新线改建工程开工仪式在建通公司举行科技大典，到场的人员有，哈哈明，明明连，联动性！</div> -->
                            </div>  
                        </div>
                    </div>
                </div>
            </div>
            <!-- 公告公示 -->
            <div class="gggs_content">
                <div class="left_ico">
                    <img src="../../assets/images/gggs-ico.png" />
                    <div class="left_title">
                        通知<br />公告
                    </div>
                </div>
                <div class="right_gggs">
                    <ul>
                        <li class="cursor"  @click="ShowDetail(item.id,'statisticalknowledge')"  v-for="(item, index) in zygg.slice(0, 2)" :key="index"> {{ item.title }}</li>
                    </ul>
                </div>
            </div>
            <!-- 项目展示 -->
            <div class="xmzs_cotent">
                <div class="news-item">
                    <div class="title">
                        项目展示 <div class="more"> <router-link  :to="{path:'/Column',query:{category:'file'}}" >
              更多 ></router-link>
                        </div>
                    </div>
                    <div class="xmzs_content">
                        <ul>
                            <li  class="cursor"  v-for="item in analysis" :key="item.id"  @click="ShowDetail(item.id,'file')">
                                {{ item.title }}
                                <span class="time"> {{ item.publishTime.slice(0, 10) }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="news-item">
                    <div class="title">
                        公告公示 <div class="more"><router-link  :to="{path:'/Column',query:{category:'gsgg'}}" >更多 ></router-link>
                        </div>
                    </div>
                    <div class="xmzs_content">
                        <ul>
                            <li class="cursor"  v-for="item in gsgg" :key="item.id"  @click="ShowDetail(item.id,'gsgg')">
                                {{ item.title }}
                                <span class="time"> {{ item.publishTime.slice(0, 10) }}</span>
                            </li>
                           
                        </ul>
                    </div>
                </div>
            </div>
            <!-- 党建工作 -->
        </div>
        <div class="bg-grey">
            <div class="page-content">
                <div class="xmzs_cotent">
                    <div class="news-item">
                        <div class="title">
                            党建工作 <div class="more"> <router-link  :to="{path:'/Column',query:{category:'statistics'}}" >更多 ></router-link>
                            </div>
                        </div>
                        <div class="xmzs_content">
                            <ul>
                                <li class="cursor" v-for="item in file" :key="item.id"  @click="ShowDetail(item.id,'statistics')">
                                {{ item.title }}
                                <span class="time"> {{ item.publishTime.slice(0, 10) }}</span>
                            </li>
                            </ul>
                        </div>
                    </div>
                    <div class="news-item">
                        <div class="title">
                            人才招募 <div class="more"> <router-link  :to="{path:'/Column',query:{category:'people'}}" >更多 ></router-link>
                            </div>
                        </div>
                        <div class="xmzs_content">
                            <ul>
                                <li class="cursor"  v-for="item in data" :key="item.id"  @click="ShowDetail(item.id,'people')">
                                {{ item.title }}
                                <span class="time"> {{ item.publishTime.slice(0, 10) }}</span>
                            </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script >
export default {
    name: 'home',
    data() {
        return {
            params: {
                catalog: 'picture',
                page: 0,
                size: 10,
            },
            pictureList: [],
            lits: [], //工作动态
            analysis: [], // 统计文化
            info: [], // 统计信息
            file: [], //文件汇编
            data: [], //统计数据
            knowledge: [], //统计知识
            law: [], //统计法制
            culture: [], //统计文化
            notice: [], //通知公告
            zygg:[],
            gsgg:[]

        }
    },
    created() {
        this.getHome()
    },
    computed: {
        imageBaseUrl() {
            // console.log(process.env.VUE_APP_BASE_API, "打印地址")
            return this.$imgUrl
        }
    },
    
    methods: {
        getHome() {
            let self = this
            this.$http('/api/document/list', this.params).then(data => {
              self.lits = data.data.companyDynamic; // 公司动态
              self.analysis = data.data.projectShow; // 项目展示
              self.info = data.data.bidAnnouncement; // 招投标公告
              self.file = data.data.partyBuilding; // 党建工作
              self.data = data.data.talentRecruitment; // 人才招募
              self.knowledge = data.data.knowledge; //统计知识
              self.law = data.data.law; //统计法制
              self.culture = data.data.culture; //统计文化
              self.notice = data.data.publicAnnouncement;
              self.pictureList = data.data.groupDynamic;
              self.gsgg = data.data.NoteAnnouncement;
              self.zygg = data.data.ImportAnnounce

                
            })
            .catch((error) => {
                console.log(error)
            })
        },
        ShowDetail(id,type){
            this.$router.push({
            path: '/Detail',
            query: {
            id:id,category:type
            },
      });
        }
    }
}
</script>

<style scoped lang="less">
.page-content {
    width: 1160px;
    margin: 0 auto;
    text-align: left;
}

.bg-grey {
    height: 341px;
    background: #F6F7FA;
}

.company_trends {
    padding-top: 30px;
    display: flex;

    .img_news {
        width: 803px;
        height: 530px;

        ::v-deep .el-carousel {
            width: 803px;
            height: 530px;

        }
    }

    .trends_news {
        width: 358px;
        height: 530px;
        background: rgba(242, 244, 247, 0.5);
        padding: 20px;

        .new_title {
            display: flex;

            img {
                width: 17px;
                height: 20px;
                margin-right: 8px;
            }

            font-size: 20px;
            font-family: AlibabaPuHuiTiB;
            color: #2E2F38;
            line-height: 27px;
            padding-bottom: 13px;
            border-bottom: 1px solid #DEDEDE;
        }

        .new_list {

            overflow: hidden;
            display: flex;
            flex-direction: column;
            height: 530px;

            .list_art {
                padding: 16px 0;
                display: flex;
                flex-direction: row;
                border-bottom: 1px dashed #DEDEDE;

                .time {
                    width: 50px;
                    height: 50px;
                    background: rgba(222, 233, 246, 0.6);
                    border-radius: 4px;
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #40474B;
                    line-height: 50px;
                    text-align: center;
                }

                .list-title {
                    width: 348px;
                }

                .art_title {
                    padding-left: 12px;
                    font-size: 16px;
                    font-family: AlibabaPuHuiTiM;
                    color: #2E2F38;
                    font-weight: 600;
                    overflow: hidden;
                    line-height: 18px;
                    text-overflow: ellipsis;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1; //限制显示2行
                    display: -webkit-box;
                }

                .art_time {
                    margin-top: 8px;
                    padding-left: 12px;
                    font-size: 12px;
                    font-family: AlibabaPuHuiTiM;
                    color: #96999D;
                    overflow: hidden;
                    line-height: 18px;
                    text-overflow: ellipsis;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1; //限制显示2行
                    display: -webkit-box;
                }

                .art_content_short {
                    padding-left: 12px;

                    // height: 36px;
                    font-size: 13px;
                    font-family: AlibabaPuHuiTiR;
                    color: #96999D;
                    line-height: 18px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2; //限制显示2行
                }

            }
        }
    }
}

.gggs_content {
    margin-top: 30px;
    height: 84px;
    width: 1160px;
    display: flex;

    .left_ico {
        display: flex;

        img {
            width: 84px;
            height: 84px;
        }

        .left_title {
            width: 84px;
            height: 84px;
            background: #F2F4F7;
            line-height: 30px;
            text-align: center;
            font-size: 22px;
            font-family: AlibabaPuHuiTiB;
            align-items: center;
            display: flex;
            justify-content: center;
            color: #3258A2;
        }
    }

    .right_gggs {
        width: 982px;
        // height: 84px;
        background: #F8F9FB;
        margin-left: 10px;
        padding: 15px 21px;

        li {
            font-size: 16px;
            font-family: AlibabaPuHuiTiR;
            color: #40474B;
            text-indent: 20px;
            line-height: 22px;
            position: relative;
        }

        li::before {
            position: absolute;
            content: "";
            width: 16px;
            height: 16px;
            top: 5px;
            left: 0;
            background: url(../../assets/images/new-gs.png) no-repeat;
            background-size: 100% 100%;
        }

        li:nth-child(2) {
            margin-top: 10px;
        }
    }
}

.xmzs_cotent {
    padding-top: 30px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;


}

.news-item {
    width: 550px;

    .title {
        height: 38px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border-bottom: 1px solid #D8D8D8;
        position: relative;
        font-size: 20px;
        font-family: AlibabaPuHuiTiB;
        color: #2E2F38;

        .more {
            font-size: 14px;
            font-family: AlibabaPuHuiTiR;
            color: #56A1F3;
            line-height: 20px;
        }
    }

    .title::after {
        content: "";
        position: absolute;
        width: 60px;
        height: 4px;
        background: #3258A2;
        bottom: -2px;
        left: 0;
    }

    .xmzs_content {
        height: 200px;
        overflow: hidden;

        ul li {
            list-style-type: square;
        }

        li {
            list-style-type: circle !important;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-top: 20px;
            font-size: 14px;
            font-family: AlibabaPuHuiTiR;
            color: #2E2F38;
            line-height: 20px;

            .time {
                display: block;
                font-size: 14px;
                font-family: AlibabaPuHuiTiR;
                color: rgba(46, 47, 56, 0.44);
                line-height: 20px;
            }
        }
    }
}</style>
